import { ButtonBase, Menu, MenuItem, Typography } from '@material-ui/core'
import React, { FC, useState } from 'react'

import { getTranslate } from '../../localization'
import { NumberFieldData } from '../../mockData/inventory'
import AllocationHistoryModal from './AllocationHistoryModal'
import ReservationNumbersModal from './ReservationNumbersModal'
import useStyles from './styles/InventoryRoomtypeBox.styles'

interface AllocatedNumberBoxProps {
  availItem: NumberFieldData
  propertyCode: string
  roomtypeCode: string
  channelID: string
  weekendIndexes: number[]
  index: number
}
const AllocatedNumberBox: FC<AllocatedNumberBoxProps> = ({
  availItem,
  propertyCode,
  roomtypeCode,
  channelID,
  weekendIndexes,
  index
}) => {
  const classes = useStyles()

  const [anchorEl, setAnchorEl] = useState<
    (EventTarget & HTMLButtonElement) | null
  >(null)

  const handleClose = () => {
    setAnchorEl(null)
  }

  const [reservationNumberModalIsOpen, setreservationNumberModalIsOpen] =
    useState(false)

  const [allocationHistoryModalIsOpen, setallocationHistoryModalIsOpen] =
    useState(false)

  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setAnchorEl(event.currentTarget)
  }

  return (
    <div
      key={`${availItem.date}`}
      className={[
        classes.dayContainer,
        weekendIndexes.includes(index % 7) ? classes.weekendDayContainer : ''
      ].join(' ')}>
      <ButtonBase onClick={handleClick}>
        <Typography variant="body1">{availItem.value}</Typography>
      </ButtonBase>

      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}>
        <MenuItem onClick={() => setreservationNumberModalIsOpen(true)}>
          {getTranslate('Reservation Numbers')}
        </MenuItem>
        <MenuItem onClick={() => setallocationHistoryModalIsOpen(true)}>
          {getTranslate('Allocation History')}
        </MenuItem>
      </Menu>
      {reservationNumberModalIsOpen && (
        <ReservationNumbersModal
          input={{
            channelID: channelID,
            date: availItem.date,
            propertyCode: propertyCode,
            roomTypeCode: roomtypeCode
          }}
          isOpen={reservationNumberModalIsOpen}
          onClose={() => setreservationNumberModalIsOpen(false)}
        />
      )}
      {allocationHistoryModalIsOpen && (
        <AllocationHistoryModal
          input={{
            channelID: channelID,
            date: availItem.date,
            propertyCode: propertyCode,
            roomTypeCode: roomtypeCode
          }}
          isOpen={allocationHistoryModalIsOpen}
          onClose={() => setallocationHistoryModalIsOpen(false)}
        />
      )}
    </div>
  )
}

export default AllocatedNumberBox
